import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const SupplierDevelopment = () => {
  const navigate = useNavigate ();

const actions = [
  {
    label: 'Supplier List',
    desc: 'Registered supplier directory',
    icon: (
      <svg viewBox="0 0 24 24">
        <ellipse cx="12" cy="5" rx="9" ry="3"/>
        <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
      </svg>
    ),
  },
  {
    label: 'Development Plans',
    desc: 'Supplier development roadmaps',
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
  },
  {
    label: 'Contributions',
    desc: 'SD financial contributions and support',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
  },
  {
    label: 'Supplier Development Scorecard',
    onClick: () => navigate('/esd/supplier-development/scorecard'),
    desc: 'Supplier Development scorecard data and compliance tracking',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="1"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
      </svg>
      ),
  },
  {
    label: 'Progress Tracking',
    desc: 'Monitor supplier growth milestones',
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </svg>
    ),
  },
  {
    label: 'Reports',
    desc: 'Supplier development reporting',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
      </svg>
    ),
  },
  {
    label: 'Submit Data',
    desc: 'Enter and submit scorecard data',
    icon: (
      <svg viewBox="0 0 24 24">
        <line x1="22" y1="2" x2="11" y2="13"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    ),
  },
];

  return (
    <DashboardPage
      theme="supplier_development"
      title="Supplier Development"
      subtitle="ESD — Supplier Development Element"
      actions={actions}
    />
  );
};

export default SupplierDevelopment;
